"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_icons_1 = require("react-bootstrap-icons");
const CardStyles_1 = require("../card/CardStyles");
const ReserveDetailStyles_1 = require("./ReserveDetailStyles");
const ReserveDetail = () => {
    const amenities = {
        wifi: true,
        kitchen: false,
        balcony: true,
        tv: true,
        airCond: true,
        security: true,
    };
    const installations = {
        parking: true,
        pool: false,
        concierge: true,
        gym: false,
        laundry: false,
        playground: true,
    };
    return (react_1.default.createElement(ReserveDetailStyles_1.Container, null,
        react_1.default.createElement(CardStyles_1.Row, null,
            react_1.default.createElement("div", { className: "flex" },
                react_1.default.createElement("div", { className: "diffs" },
                    react_1.default.createElement("span", null, "Comodidades"),
                    react_1.default.createElement("div", { className: "iconGroup" },
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: amenities.wifi },
                            react_1.default.createElement(react_bootstrap_icons_1.EmojiSmile, { color: amenities.wifi ? '#fff' : '#777', size: 22 })),
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: amenities.kitchen },
                            react_1.default.createElement(react_bootstrap_icons_1.Cart4, { color: amenities.kitchen ? '#fff' : '#777', size: 22 })),
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: amenities.balcony },
                            react_1.default.createElement(react_bootstrap_icons_1.Tools, { color: amenities.balcony ? '#fff' : '#777', size: 22 })),
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: amenities.airCond },
                            react_1.default.createElement(react_bootstrap_icons_1.Shop, { color: amenities.airCond ? '#fff' : '#777', size: 22 })),
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: amenities.security },
                            react_1.default.createElement(react_bootstrap_icons_1.GeoAlt, { color: amenities.security ? '#fff' : '#777', size: 22 })))),
                react_1.default.createElement("div", { className: "diffs" },
                    react_1.default.createElement("span", null, "Instala\u00E7\u00F5es"),
                    react_1.default.createElement("div", { className: "iconGroup" },
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: installations.parking },
                            react_1.default.createElement(react_bootstrap_icons_1.Tag, { color: installations.parking ? '#fff' : '#777', size: 22 })),
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: installations.pool },
                            react_1.default.createElement(react_bootstrap_icons_1.Cart4, { color: installations.pool ? '#fff' : '#777', size: 22 })),
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: installations.laundry },
                            react_1.default.createElement(react_bootstrap_icons_1.House, { color: installations.laundry ? '#fff' : '#777', size: 22 })),
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: installations.concierge },
                            react_1.default.createElement(react_bootstrap_icons_1.Person, { color: installations.concierge ? '#fff' : '#777', size: 22 })),
                        react_1.default.createElement(ReserveDetailStyles_1.IconCircle, { active: installations.playground },
                            react_1.default.createElement(react_bootstrap_icons_1.Calendar3, { color: installations.playground ? '#fff' : '#777', size: 22 }))))),
            react_1.default.createElement("div", { className: "flex" },
                react_1.default.createElement(ReserveDetailStyles_1.StyledButton, { id: "reserveDetail" }, "Dados do pedido"),
                react_1.default.createElement(ReserveDetailStyles_1.StyledButton, null, "Estender a reserva"))),
        react_1.default.createElement("hr", null),
        react_1.default.createElement(CardStyles_1.Row, null,
            react_1.default.createElement("div", { className: "groupWrapper" },
                react_1.default.createElement("div", { className: "priceGroup" },
                    react_1.default.createElement("span", { className: "commonText" }, "4 Di\u00E1rias x R$ 139,00"),
                    react_1.default.createElement("span", null, "R$ 566,00")),
                react_1.default.createElement("div", { className: "priceGroup" },
                    react_1.default.createElement("span", { className: "commonText" }, "Taxa de limpeza"),
                    react_1.default.createElement("span", null, "R$ 75,00"))),
            react_1.default.createElement("div", { className: "groupWrapper" },
                react_1.default.createElement("div", { className: "priceGroup" },
                    react_1.default.createElement("span", { className: "couponText" }, "Cupom (-10%)"),
                    react_1.default.createElement("span", { className: "couponText" }, "R$ -35,30")),
                react_1.default.createElement("div", { className: "priceGroup" },
                    react_1.default.createElement("span", { className: "totalText" }, "Total"),
                    react_1.default.createElement("span", { className: "totalValue" },
                        "R$ \u00A0",
                        react_1.default.createElement("span", null, "317,"),
                        "70"))))));
};
exports.default = ReserveDetail;
